<template>
  <RevDrawer
    :name="MODAL_NAMES.VERIFIED_REFURBISHED"
    :title="i18n(translations.modalTitle)"
  >
    <template #body>
      <RevIllustration
        alt=""
        class="mb-24 w-full"
        :height="180"
        src="/img/verified-refurbished/illustration.png"
        :width="327"
      />

      <h3 class="heading-1">
        {{ i18n(translations.title) }}
      </h3>

      <RevDivider class="my-24" />

      <ContentRow
        :labels="[i18n(translations.item1text)]"
        :title="i18n(translations.item1title)"
      >
        <IconStarOutlined aria-hidden />
      </ContentRow>
      <ContentRow
        :labels="[i18n(translations.item2text)]"
        :title="i18n(translations.item2title)"
      >
        <IconCheckInCircle aria-hidden />
      </ContentRow>
      <ContentRow
        :labels="[i18n(translations.item3text)]"
        :title="i18n(translations.item3title)"
      >
        <IconHeadset aria-hidden />
      </ContentRow>

      <slot />
    </template>
    <template v-if="shouldDisplayButton" #footer>
      <RevButton
        full-width="always"
        target="_blank"
        :to="link"
        variant="primary"
        @click="
          tracking.trackClick({
            zone: 'verified_refurbished',
          })
        "
      >
        {{ i18n(translations.readMore) }}
      </RevButton>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevDivider } from '@ds/components/Divider'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconHeadset } from '@ds/icons/IconHeadset'
import { IconStarOutlined } from '@ds/icons/IconStarOutlined'
import type { Location } from '@ds/types/Location'

import ContentRow from '../ContentRow.vue'
import { MODAL_NAMES } from '../constants'

import translations from './VerifiedRefurbishedModal.translations'

defineProps<{
  link: Location
}>()

const i18n = useI18n()
const { countryCode } = useMarketplace().market
const config = useRuntimeConfig()
const tracking = useTracking()

const shouldDisplayButton = computed(() => {
  return config.public.FF_ENABLE_VERIFIED_REFURBISHED_LINK_PP?.includes(
    countryCode,
  )
})
</script>
